<template>
  <div class="page">
    <Header
        :title=pageTitle
        :filter=pageFilter
        :total=pageTotal
    />
    <div v-show="isDataVisible" class="container dashboard card">
      <div class="card-header">
        <span class="other-buttons">
          <button @click="downloadTable()" class="btn btn-primary">
            <i class="fa fa-download"></i>
          </button>
        </span>
        <span class="other-buttons">
          <button @click="newItemForm()" class="btn btn-primary">New</button>
        </span>
        <span class="special-buttons">
          <button @click="runDiscoverHV()" :class="'btn btn-default run-btn ' + DiscoverHV.status ">Discover HW</button>
        </span>
        <span class="special-buttons" v-tippy="{arrow : true, onShow: () => itemsSelectedCount === 0 }"
              title="Please select Server to delete">
        <button class="btn btn-default delete-btn small icon-only"
                @click="openDeleteItemsConfirmation()"
                :class="['btn btn-danger', { 'disabled': itemsSelectedCount === 0 }]">
          Delete <span v-if="itemsSelectedCount <= 1">Server</span><span v-else>Servers</span> <i
            class="fa fa-trash"></i>
        </button>
        </span>
      </div>
      <div class="card-body">
        <div class="alert alert-info alert-dismissable" v-show="info != ''">
          <strong>
            <b-icon icon="info-circle-fill"></b-icon>
          </strong>
          <div class="alert-text" style="display: inline-block;"> {{ info }}</div>
        </div>
        <div v-bind:class="loading"></div>
        <table class="table table-responsive-sm" id="resizable-table">
          <thead>
          <tr>
            <th scope="col" style="max-width: 40px">
              <div class="flex">
                <span class="col-text" @click="SortInvert('Id')">ID</span>
                <span class="icon-up" v-show="sortField=='Id'"><b-icon icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField==`-Id`"><b-icon icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex"  style="width: 4rem;">
                <span class="col-text" @click="SortInvert('State')">State 🚦</span>
                <span class="icon-up" v-show="sortField=='State'"><b-icon icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField==`-State`"><b-icon icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex">
                <span class="col-text">Links 🔗</span>
              </div>
            </th>
            <th scope="col" style="max-width: 70px">
              <div class="flex">
                <span class="col-text" @click="SortInvert('Name')">Name 🔡</span>
                <span class="icon-up" v-show="sortField=='Name'"><b-icon icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField==`-Name`"><b-icon icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col" style="max-width: 150px">
              <div class="flex">
                <span class="col-text" style="width: 3rem;" @click="SortInvert('Name')">Type 📃</span>
                <span class="icon-up" v-show="sortField=='Name'"><b-icon icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField==`-Name`"><b-icon icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col" style="max-width: 100px">
              <div class="flex">
                <span class="col-text" @click="SortInvert('Ip')">IP ɪᴘ</span>
                <span class="icon-up" v-show="sortField=='Ip'"><b-icon icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField==`-Ip`"><b-icon icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col" style="max-width: 70px">
              <div class="flex">
                <span class="col-text" style="width: 3rem;" @click="SortInvert('Cpu')">CPU 🔋</span>
                <span class="icon-up" v-show="sortField=='Cpu'"><b-icon icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField==`-Cpu`"><b-icon icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex">
                <span class="col-text" style="width: 3rem;" @click="SortInvert('Ram')">RAM 🟰</span>
                <span class="icon-up" v-show="sortField=='Ram'"><b-icon icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField==`-Ram`"><b-icon icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex">
                <span class="col-text" style="width: 5rem;" @click="SortInvert('Ssd')">SSD/HDD 💽</span>
                <span class="icon-up" v-show="sortField=='Ssd'"><b-icon icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField==`-Ssd`"><b-icon icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col" style="width: 10rem">
              <div class="flex">
                <span class="col-text" @click="SortInvert('DcName')">Datacenter 🌐</span>
                <span class="icon-up" v-show="sortField=='DcName'"><b-icon icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField==`-DcName`"><b-icon icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex">
                <span class="col-text"></span>
              </div>
            </th>
            <th scope="col" class="text-center">
              <b-checkbox
                  @change="selectAll()"
                  v-model="allSelected"
              ></b-checkbox>
            </th>
          </tr>
          <ServerFilters
              :onChanged="filterChanged"
              @changeTitle="changeTitle"
              v-on:onChanged="filterChanged"
              v-on:onInit="filterInit"
              :filter="filterOptions"
              @deleteItems="openDeleteItemsConfirmation()"
              :filterExactProp="filterExact"
              :filterValues="filterValues"
          />
          </thead>
          <tbody v-if="items !== null && items.length > 0">
          <tr
              v-for="item in items"
              v-bind:key="item.id"
              @click="rowClick(item, $event)"
              :data-item-id="item.Id"
              :id="'item' + item.Id"
              :class="{'selected':selectedItemsList.indexOf(item.Id) >= 0}"

          >
            <td class="text-left"><span class="cel-text"> {{ item.Id }} </span></td>
            <td class="text-left">
                <span class="cel-text" v-tippy="{arrow : true}"
                      :title="'state: ' + item.State + ' Discovered At: ' + item.DiscoveredAt" style="all: initial;">
                <span v-if="item.State === 'OK'">🟢</span>
                <span v-else-if="item.State === 'NO PING'">🔴</span>
                <span v-else-if="item.State === 'ERROR'">⭕️</span>
                <span v-else-if="item.State === 'TIMEOUT'">⌛</span>
                <span v-else-if="item.State === 'FAIL_AUTH'">🔐</span>
                <span v-else-if="item.State === '' || item.State == null">0️⃣️</span>
                <span v-else>🤷️</span>
                </span>
            </td>
            <td class="text-left">
                <span class="cel-buttons">
                  ({{item.VmCount}})<a :href="fillTemplate(linkToVms, item)" class="btn btn-as-link text-info icon-only">
                    <img title="VMs" class="item-icon" src="/img/vm.png">
                  </a>
                 <a class="btn btn-as-link icon-only"
                    :href='`/#/ip/list?page=1&filter=[{"Condition":"=","Data":{"ServerId":${item.Id}}}]`'>
                  <img title="ESXi" class="item-icon" src="/img/ip.png">
                </a>
                </span>
            </td>
            <td class="text-left">
                <span style="white-space: nowrap" class="cel-text" v-if="typeList[item.Entity]">
                  <a v-if="typeList[item.Entity].toLowerCase() === 'esxi'" :href="`https://${item.Ip}`" target="_blank">
                    <span class='server-name'>{{ item.Name }}</span>
                    <br><span class='server-model'>{{ item.RealName }}</span>
                    <br><span v-if="item.Comment" v-tippy="{arrow : true, interactive: true}" :title=" item.Comment"
                              class='esxi-field-comment field-comment'>{{ item.Comment }}</span>
                  </a>
                  <span v-else>
                    <span class='server-name'>{{ item.Name }}</span>
                    <br><span class='server-model'>{{ item.RealName }}</span>
                    <br><span v-if="item.Comment" v-tippy="{arrow : true, interactive: true}" :title=" item.Comment"
                              class='esxi-field-comment field-comment'>{{ item.Comment }}</span>
                  </span>
                </span>
            </td>
            <td class="text-center">
              <span class="cel-text" v-if="typeList[item.Entity]">
                <span
                    v-if="typeList[item.Entity].toLowerCase() === 'ipmi'"
                    v-tippy="{arrow : true}"
                    title="ipmi"
                >🔌</span>
                <span
                    v-else-if="typeList[item.Entity].toLowerCase() === 'baremetal'"
                    v-tippy="{arrow : true}"
                    title="baremetal"
                >🗿</span>
                <span
                    v-else-if="typeList[item.Entity].toLowerCase() === 'esxi'"
                    v-tippy="{arrow : true}"
                    title="esxi"
                >📟️</span>
                <span
                    v-else-if="typeList[item.Entity].toLowerCase() === 'vps'"
                    v-tippy="{arrow : true}"
                    title="vps"
                >🌩</span>
                <span
                    v-else-if="typeList[item.Entity].toLowerCase() === 'proxmox'"
                    v-tippy="{arrow : true}"
                    title="proxmox"
                >📻</span>
              </span>
            </td>
            <td class="text-left"><span class="cel-text">
                 <span v-if="item.IpState === 'OK'" v-tippy="{arrow : true}"
                       title="Ip is pinging">🟢
                   <span class="copy-click" @click="(event) => copyText(item.Ip, event)">
                    <span class="text-for-copy">{{ item.Ip }}</span>
                    <i class="fa fa-copy"></i><i class="fa fa-check"></i><i class="fa fa-ban"></i>
                   </span>
                 </span>
                <span v-else v-tippy="{arrow : true}" title="Ip does not ping">🔴
                   <span class="copy-click" @click="(event) => copyText(item.Ip, event)">
                    <span class="text-for-copy">{{ item.Ip }}</span>
                    <i class="fa fa-copy"></i><i class="fa fa-check"></i><i class="fa fa-ban"></i>
                   </span>
                </span>
              </span></td>
            <td class="text-left">
              <span class="cel-text" v-if="typeList[item.Entity] && typeList[item.Entity].toLowerCase() === 'vps'">N/A</span>
              <span class="cel-text" v-else> {{ item.Cpu }} <span v-if="item.Threads">( {{item.Threads }} )</span></span>
            </td>
            <td v-if="typeList[item.Entity] && typeList[item.Entity].toLowerCase() === 'baremetal'"
                class="text-left">
              <span v-if="(parseInt(item.Ram) || 0) > 0">{{ (parseInt(item.Ram) || 0) }}</span>
            </td>
            <td class="cel-text" v-else-if="typeList[item.Entity] && typeList[item.Entity].toLowerCase() === 'vps'">N/A</td>
            <td v-else-if="typeList[item.Entity]" class="text-left">
              <div v-if="(parseInt(item.Ram) || 0) > 0" class="d-flex flex-column">
                  <span class="d-flex gap-1">
                    <span style="white-space: nowrap">
                      <span class="fw-bold ram-vm-color">VMRAM: </span>
                      <span class="ram-vm-color">{{ (parseInt(item.VmSum) || 0) }}</span>
                    </span>
                    <span style="white-space: nowrap">
                      <span class="fw-bold ram-usage-color">Used: </span>
                      <span class="ram-usage-color">{{ (parseInt(item.RamUsage) || 0) }}</span>
                    </span>
                    <span style="white-space: nowrap"><span class="fw-bold">Free: </span>{{
                        (parseInt(item.Ram) || 0) - (parseInt(item.RamUsage) || (parseInt(item.VmSum) || 0))
                      }}</span>
                    <span style="white-space: nowrap"><span class="fw-bold">Cap: </span>{{ (parseInt(item.Ram) || 0) }}</span>
                  </span>
                <span class="progress-container ram-vm-color">
                        <progress style="width: 100%"
                                  :value="(parseInt(item.VmSum) || 0)"
                                  :max="(parseInt(item.Ram) || 0)">
                        </progress>
                </span>
                <span class="progress-container ram-usage-color">
                        <progress style="width: 100%"
                                  :value="(parseInt(item.RamUsage) || 0)"
                                  :max="(parseInt(item.Ram) || 0)">
                        </progress>
                </span>
              </div>
            </td>
            <td v-else></td>
            <td class="cel-text" v-if="typeList[item.Entity] && typeList[item.Entity].toLowerCase() === 'vps'">N/A</td>
            <td v-else class="text-left"><span class="cel-text">
                  <div class="bar-wrapper">
                    <span class='d-flex flex-column' style="text-align: left">
                      <span><span class="fw-bolder">SSD:</span> {{ item.Ssd }}</span>
                      <span><span class="fw-bolder">HDD:</span> {{ item.Hdd }}</span></span>
                  </div>
              </span></td>
            <td class="text-left"><span class="cel-text"> {{ item.DcName }} </span></td>
            <td class="text-left">
                <span class="cel-buttons">
                  <button class="btn btn-as-link icon-only" @click="editItem(item)">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button class="btn btn-as-link icon-only" @click="refresh(item.Ip)">
                    <i class="fa fa-refresh"></i>
                  </button>
                  <button class="btn btn-as-link text-danger icon-only" @click="openDeleteItemConfirmation(item)">
                    <i class="fa fa-trash"></i>
                  </button>
                </span>
            </td>
            <td class="text-center">
              <b-checkbox
                  v-model="selectedItemsList"
                  :value="item.Id"
              ></b-checkbox>
            </td>
          </tr>
          </tbody>
        </table>
        <p class="text-center" v-if="items === null || items.length === 0">Nothing found</p>
        <ListControls
            v-else
            v-on:onLimitChanged="ChangeLimit"
            :total="total"
            :options="[
                {value: '10',text: '10'},
                {value: '50',text: '50'},
                {value: '100',text: '100'},
                {value: '500',text: '500'},
                {value: '1000',text: '1000'},
            ]"
        />
      </div>
    </div>

    <ServerEdit :currentItem="currentItem"/>
    <NewServer v-on:onSuccess="itemSuccess"/>

    <ModalConfirmItemDelete
        v-on:onComplete="deletedItem"
        v-on:onError="deletedItemErr"
        :title="confirmModalTitle"
        :msg="confirmModalMsg"
        :url="apiUrl"
        :itemId="currentItemId"
    />

    <ModalLog :data="textareaData" :modalName="'modalTextarea'"/>

    <ModalError name="listError" :message="error"/>

    <ModalSuccess name="listSuccess" :message="success"/>
    <ModalConfirm
        :msg="confirmModalMsg"
        :title="confirmModalTitle"
        v-on:onModalСonfirmEvent="modalConfirmEvent"/>
    <DeleteServer :items="items" :selectedItemsList="selectedItemsList" @delete="deleteItems"/>
  </div>
</template>
<script>

import axios from 'axios';

// mixins
import {TokenMixin} from '@/assets/js/mixins/token-mixin';
import {UserStoredDataMixin} from '@/assets/js/mixins/user-stored-data-mixin';
import {ListLogicMixin} from '@/assets/js/mixins/list-logic-mixin';
import ServerFilters from "@/components/filters/ServerFilters.vue";
import _ from "lodash";
import NewServer from "@/components/modal/NewServer.vue";
import DeleteServer from "@/components/modal/DeleteServer.vue";
import ServerEdit from "@/components/modal/ServerEdit.vue";
import { EventBus } from '@/eventBus';

export default {
  name: 'listPage',
  mixins: [
    TokenMixin,
    UserStoredDataMixin,
    ListLogicMixin
  ],
  components: {
    ServerEdit,
    DeleteServer,
    NewServer,
    ServerFilters

  },
  data() {
    return {
      pageTitle: 'Servers',
      pageFilter: '',
      pageTotal: '',
      total: 0,
      title: 'Servers',
      items: null,
      apiList: '/api/manager/server/list',
      linkToVms: '/#/vm/list?filter=[{"Condition":"=","Data":{"Server":"##Name##"}},{"Condition":"=","Data":{"DcId":##DcId##}}]',
      apiItem: '',
      apiUrl: '/api/manager/server/',
      apiMultyDelete: '/api/manager/server/delete',
      currentItem: {},
      apiConfig: '/api/config/list',
      apiTypeList: '/api/manager/server-entities',
      typeList: [],
      columns: [
        {name: "Id", value: "Id"},
        {name: "Name", value: "Name"},
        {name: "Ip", value: "Ip"},
        {name: "Cpu/Ram/VmRam/Ssd/Hdd", value: "Cpu"},
        {name: "CRUD", value: "CRUD"},
      ],
      options: [],
      DiscoverHV: {
        api: "/api/manager/monitor/start/server",
        apiStatus: "/api/launcher/status",
        status: "",
        name: "DiscoverHV",
        timer: true,
      },
      textareaData: '',
      queryFilter: [],
      allSelected: false,
      filterOptions: [
        {
          name: "Entity",
          uri: "/api/manager/server-entities",
          method: "get",
          options: [{value: "", label: "ANY"}]
        },
        {
          name: "Platform",
          uri: "/api/manager/server/flat?group=Platform",
          labelField: "Platform",
          valueField: "Platform",
          options: [{value: "", label: "ANY"}]
        },
        {
          name: "Model",
          uri: "/api/manager/server/flat?group=Model",
          labelField: "Model",
          valueField: "Model",
          options: [{value: "", label: "ANY"}]
        },
        {
          name: "State",
          uri: "/api/manager/server/flat?group=State",
          labelField: "State",
          valueField: "State",
          options: [{value: "", label: "ANY"}]
        },
        {
          name: "DcName",
          uri: "/api/manager/dc/flat?sort=Id",
          valueField: "Name",
          labelField: "Name",
          options: [{value: "", label: "ANY"}]
        },
        {
          name: "Name",
          uri: "/api/manager/server/flat?group=Name",
          valueField: "Name",
          labelField: "Name",
          options: [{value: "", label: "ANY"}]
        },
      ],
      filterValues: {
        "State":"",
        "Entity":"",
        "DcId":"",
        "DcName":"",
        "Name":"",
      },
    };
  },
  methods: {
    deleteItems(deleteIp = 0) {
      const itemsIds = [...this.selectedItemsList]
      axios.post(`/api/manager/server/delete?delete_ip=${deleteIp}`,
          itemsIds,
          this.authRespConf())
          .catch((err) => {
            this.unselectItemsList(itemsIds);
            this.errorHandle(err, true, true);
          })
          .then(res => {
            if (res !== null && res !== undefined) {
              Array.from(document.getElementsByClassName('selected')).forEach(function (el) {
                el.classList.remove('selected');
              });
              this.unselectItemsList(itemsIds);
            }
          });
    },
    newItemForm() {
      this.currentNewItemId = 0;
      this.$modal.show('createServer');
    },
    selectAll: function () {
      this.selectedItemsList = [];
      if (this.allSelected) {
        let index;
        for (index in this.items) {
          this.selectedItemsList.push(this.items[index].Id);
        }
      }
    },
    openDeleteItemsConfirmation() {
      this.$modal.show('DeleteServer');
    },
    openDeleteItemConfirmation(item) {
      this.selectedItemsList = [item.Id]
      this.$modal.show('DeleteServer');
    },
    changeTitle(title) {
      this.pageTitle = title;
    },
    runDiscoverHV() {
      this.error = '';
      this.DiscoverHV.status = 'running';
      axios.post(this.DiscoverHV.api,
          [],
          this.authRespConf())
          .catch((err) => {
            this.errorHandle(err, true, true);
            this.DiscoverHV.status = '';
          })
          .then(res => {
            if (res !== null && res !== undefined) {
              this.info = 'Running';
              setTimeout(this.clearInfo, 5000);
              // setTimeout(this.checkDiscoverStatus, 2000);
            }
          })
    },

    checkDiscoverStatus() {
      if (this.DiscoverHV.status === "running") {
        axios.post(this.DiscoverHV.apiStatus,
            {
              name: this.DiscoverHV.name
            },
            this.authRespConf())
            .catch((err) => {
              this.DiscoverHV.status = '';
              this.errorHandle(err, true, true);
            })
            .then(res => {
              if (res !== null && res !== undefined) {
                if (res.data != "") {
                  if (res.data.data !== "processed") {
                    this.DiscoverHV.status = "";

                    this.getAndShowDiscoverLogs();
                    this.LoadData();
                    this.success = 'Script successfully finished!';
                    this.$modal.show('success');
                  } else {
                    // setTimeout(this.checkDiscoverStatus, 2000);
                  }
                }
              }
            });
      }
    },

    editItem(item) {
      this.currentItem = item;
      this.$modal.show('ServerEdit');
    },

    getAndShowDiscoverLogs() {
      let loader = this.$loading.show();
      this.loading = 'loading';
      axios.post('/api/log/list?limit=20&sort=-id&page=1',
          [{"Condition": "ilike", "Data": {"Entity": "discover"}}],
          this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.errorHandle(err, true, true);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              let last_log = res.data.data[0];
              this.textareaData = last_log.Data;
              this.$modal.show('modalTextarea');
            } else {
              this.errorHandle(res, true, true, "Something wrong, no logs found.");
            }
          });
    },
    loadTypes() {
      axios.get(this.apiTypeList, this.authRespConf()).catch(() => {
      }).then(res => {
        this.typeList = res.data.data
      })
    },
    getOptions: function (labelField = null, valueField = null, query, key, currentOptions = [], method = "POST") {

      const options = currentOptions
      axios({
        method,
        url: query,
        headers: this.authHeader(),
        data: []
      }).then(res => {
        if (res === undefined || res === null) {
          return []
        }
        if (res.data.data !== undefined) {
          for (let dataIndex in res.data.data) {
            options.push({
              value: valueField ? res.data.data[dataIndex][valueField] : dataIndex,
              label: labelField ? key.toLowerCase() === 'state' ? this.getStateOptionLabel(res.data.data[dataIndex][labelField]) : res.data.data[dataIndex][labelField] : res.data.data[dataIndex],
            });
          }
        }
      })
      return options;
    },
    loadOptions: async function () {
      await _.forOwn(this.filterOptions, (value, key) => {
        if (value.uri && key !== 'UsedBy') {
          this.filterOptions[key].options = this.getOptions(value.labelField, value.valueField, value.uri, key, this.filterOptions[key].options, value.method ?? 'POST')
        }
      })
      this.loadTypes();
      this.filterPreparing();
      this.filterQuery();
      this.LoadData();
    },
    handleUpdateServer(item) {
      console.log("handleUpdateServer");
      if (item === undefined || item === null) {
        console.log("handleUpdateServer item null");
        return;
      }
      if (this.items === undefined || this.items === null) {
        console.log("handleUpdateServer this.items null");
        return;
      }
      console.log("handleUpdateServer item", item.length, this.items.length);
      const indexToUpdate = _.findIndex(this.items, {Id: item.Id})
      this.$set(this.items, indexToUpdate, item)
    },
    handleDeleteServer(item) {
      console.log("handleDeleteServer");
      if (item === undefined || item === null) {
        console.log("handleDeleteServer item null");
        return;
      }
      if (this.items === undefined || this.items === null) {
        console.log("handleDeleteServer this.items null");
        return;
      }
      console.log("handleDeleteServer item", item.length, this.items.length);
      const indexToDelete = _.findIndex(this.items, {Id: item})
      this.$delete(this.items, indexToDelete)
    },
    handleAddServer(item) {
      console.log("handleAddServer");
      if (item === undefined || item === null) {
        console.log("handleAddServer item null");
        return;
      }
      if (this.items === undefined || this.items === null) {
        console.log("handleAddServer this.items null");
        return;
      }
      console.log("handleAddServer length", item.length, this.items.length);
      console.log("handleAddServer item", item);
      console.log("handleAddServer items", this.items);
      if (item.length > 0) {
        for (const itemKey in item) {
          if (this.items.length === 0) {
            this.items = [item[itemKey]]
          } else {
            this.items = {...this.items, ...item[itemKey]};
          }
        }
      }
      //this.items = this.items.length > 0 ? {...this.items, ...item} : {...item}
      console.log(this.items.length);
      console.log("handleAddServer items", this.items);
    },
    modalsHide() {
      console.log("server modalsHide");
      this.$modal.hide('modalTextarea');
      this.$modal.hide('ServerEdit');
      this.$modal.hide('DeleteServer');
      this.$modal.hide('success');
    },
  },
  computed: {
    itemsSelectedCount() {
      return this.selectedItemsList.length
    }
  },
  watch: {
    '$route': function (val) {
      console.log('serv watch $route', val);
      this.onRouteChange();
      this.filterQuery();
      this.setTitleByFilters();
    },
    selectedItemsList(val) {
      if (val.length === 0) {
        this.allSelected = false
      }
    },
    queryFilter: function (val) {
      const $this = this
      if (!_.isEqual(val, this.newFilters) && this.newFilters !== undefined) {
        $this.pageTitle = 'Servers for: '
        _.forEach(val, function (field) {
          $this.pageTitle += $this.getUnnamedFilter(field)
        })

      }
      this.setTitleByFilters();
    },
  },
  created: function () {
    this.loadOptions()
    EventBus.$on("server-update", this.handleUpdate);
    EventBus.$on("server-rq", this.handleUpdate);
    EventBus.$on("server-add", this.handleAdd);
    EventBus.$on("server-delete", this.handleDelete);
    EventBus.$on("server-del", this.handleDelete);
    EventBus.$on("EscapeKeyDown", this.modalsHide);
  },
  beforeDestroy() {
    EventBus.$off("server-update", this.handleUpdate);
    EventBus.$off("server-rq", this.handleUpdate);
    EventBus.$off("server-add", this.handleAdd);
    EventBus.$off("server-delete", this.handleDelete);
    EventBus.$off("server-del", this.handleDelete);
    EventBus.$off("EscapeKeyDown", this.modalsHide);
  },
  updated: function () {
    //this.columnsReset();
    //this.updateResizable();
  }
}
</script>
<style>
.esxi-field-comment {
  display: block;
  max-width: 12rem;
  overflow: hidden;
}
</style>